module.exports = __webpack_public_path__ + "static/media/verif-success.fd9af297.jpeg";